(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $(".job-details .component-content .button").addClass("primary-cta");
    if ($(".job-details-facts img").attr("src") == "") {
      $(".job-details-facts img").remove();
    }
  });
})(jQuery);